<ng-container *ngIf="show">
    <mat-progress-bar
        class="bg-accent"
        [mode]="mode"
        [value]="progress"></mat-progress-bar>
</ng-container>
